module.exports = __webpack_public_path__ + "static/pro-workflow-f8d43ad9bbf303cf4bc15c7e41352a29.png";